import React, { useState } from 'react';
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import '../App.css';
import './Editor.css';
import axios from "axios";
// const CustomEditor = () => {
//     const [contentState, setContentState] = useState({});
//     return (
//         <div>
            
//         </div>
//         <div>
//             <header className="App-header">
//                 Sourav's blogging Website Editor
//             </header>
//             <Editor
//                 /* initialContentState={contentState}
//                 onContentStateChange={setContentState} */
//                 wrapperClassName="wrapper-class"
//                 editorClassName="editor-class"
//                 toolbarClassName="toolbar-class"
//             />
//         </div>
//     )
// }
// export default CustomEditor;





// draft.js editor

import ReactDOM from 'react-dom';
import 'draft-js/dist/Draft.css';

// const CustomEditor = () => {
//   const [text, settext] = React.useState;
//   const [editorState, setEditorState] = React.useState(
//     () => EditorState.createEmpty(),
//   );

//   return( <div>
//     <Editor editorState={editorState} onChange={setEditorState} />
//     <div>
//     <h2>HTML Forms</h2>

// <form action="/action_page.php">
//   <label for="fname">First name:</label><br/>
//   <input type="text" id="fname" name="fname" onChange={settext}>{text}</input><br/>
//   <label for="lname">Last name:</label><br/>
//   <input type="text" id="lname" name="lname" value="Doe"/><br/><br/>
//   <input type="submit" value="Submit"/>
// </form>

// <p>If you click the "Submit" button, the form-data will be sent to a page called "/action_page.php".</p>
//    </div>
//   </div>);
  
// }

// // ReactDOM.render(<Editor />, document.getElementById('container'));


// export default CustomEditor;



class CustomEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {value: ''};

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({value: event.target.value});
  }

  handleSubmit(event) {
    event.preventDefault();
    const value=this.state.value;
    const data={value};    
    axios.post("https://sheet.best/api/sheets/3e38fac0-ccb7-450a-8947-8ab16b093938",data).then((res=>{
     console.log(res);
      this.setState({value:""});
    }))
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit} method="POST">
        <label>
          <h1>Write Your Article Here...</h1>
          <br/>
          <input type="text" className='Input' value={this.state.value} onChange={this.handleChange}/>

          {/* <select value={this.state.value} onChange={this.handleChange}> */}
            {/* <option value="grapefruit">Grapefruit</option>
            <option value="lime">Lime</option>
            <option value="coconut">Coconut</option>
            <option value="mango">Mango</option> */}
          {/* </select> */}
        </label>
        <input type="submit" value="Submit" />
      </form>
    );
  }
}

export default CustomEditor;